export interface WatchlistApproverConstructor {
  id: number
  firstName: string
  lastName: string
  approvalCount: Nullable<number>
}

export class WatchlistApprover {
  readonly id: number
  readonly firstName: string
  readonly lastName: string
  readonly approvalCount: Nullable<number>

  constructor(data: WatchlistApproverConstructor) {
    this.id = data.id
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.approvalCount = data.approvalCount
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }

  get hasApprovalCount(): boolean {
    return this.approvalCount !== null && this.approvalCount > 0
  }
}
